export const location = {
  _id: "",
  name: ""
};
